<template>
    <nav id="header" :class="['navbar', scrolled ? 'is-scrolled' : 'is-nav-transparent', !scrolled && navTextDark ? 'nav-text-dark' : '']" role="navigation" aria-label="main-navigation">
        <div class="container is-hidden-mobile is-hidden-tablet-only">
            <div class="navbar-brand">
                <router-link class="navbar-item" to="/home" name="&amp;lpos=apps_scodevmw : 0">
                    <img src="../assets/icon_hope_deer.png" width="150px"/>
                </router-link>
            </div>
            <div class="navbar-menu">
                <div role="navigation" class="navbar-end has-text-centered">
                    <!-- 首页 -->
                    <router-link class="navbar-item" to="/home" style="font-size: 1.05rem">
                        {{ $t('index_1') }}
                    </router-link>
                    <!-- 公司简介 -->
                    <router-link class="navbar-item" to="/companyInfo?type=GSJJ" style="font-size: 1.05rem">
                        公司简介
                    </router-link>
                    <!-- 产品介绍 -->
                    <router-link class="navbar-item" to="/productList" style="font-size: 1.05rem">
                        产品介绍
                    </router-link>
                    <!-- 帮助文档 -->
                    <router-link class="navbar-item" to="/fileDownloadList" style="font-size: 1.05rem">
                        帮助文档
                    </router-link>
                    <!-- 联系我们（直接跳转项目合作页） -->
                    <router-link class="navbar-item" to="/item" style="font-size: 1.05rem">
                        联系我们
                    </router-link>
                    <!-- 客服电话 -->
                    <div class="navbar-item">
                        <strong style="font-size: 1.25rem;">{{ $t('index_12') }}</strong> <strong style="font-size: 1.55rem;">&nbsp;15910967510</strong>
                    </div>
                    <!-- 关于我们（已隐藏） -->
                    <!-- <div class="navbar-item has-dropdown is-hoverable navbar-group-item">
                        <span class="navbar-link">{{ $t('index_2') }}</span>
                        <div class="navbar-dropdown is-boxed">
                            <router-link class="navbar-item" to="/companyInfo?type=GSJJ">{{ $t('index_3') }}</router-link>
                            <router-link class="navbar-item" to="/companyInfo?type=RYZZ">{{ $t('index_4') }}</router-link>
                            <router-link class="navbar-item" to="/companyInfo?type=QYWH">{{ $t('index_5') }}</router-link>
                        </div>
                    </div> -->
                    <!-- 新闻资讯（已隐藏） -->
                    <!-- <div class="navbar-item has-dropdown is-hoverable navbar-group-item">
                        <span class="navbar-link">{{ $t('index_7') }}</span>
                        <div class="navbar-dropdown is-boxed navbar-group-item">
                            <router-link class="navbar-item" v-for="productType in newTypeList"
                                         :to="'/news?type=' + productType.id" :key="productType.id">
                                {{ productType.name }}
                            </router-link>
                        </div>
                    </div> -->
                    <!-- 国际化（已隐藏） -->
                    <!-- <div class="navbar-item has-dropdown is-hoverable navbar-group-item">
                        <span class="navbar-link">
                            <img src="../assets/earth.svg" width="25px" style="margin-right: 5px">
                            {{ $t('lang') }}
                        </span>
                        <div class="navbar-dropdown is-boxed">
                            <a href="javascript:" @click="changeLang('CN')" class="navbar-item router-link-exact-active router-link-active" aria-current="page">中文</a>
                            <a href="javascript:" @click="changeLang('EN')" class="navbar-item router-link-exact-active router-link-active" aria-current="page">English</a>
                            <a href="javascript:" @click="changeLang('RU')" class="navbar-item router-link-exact-active router-link-active" aria-current="page">Русский язык</a>
                        </div>
                    </div> -->
                    <!-- 微信（已隐藏） -->
                    <!-- <div class="navbar-item">
                        <div class="wechat-icon">
                            <img class="wechat-logo" src="../assets/weixin_logo.svg" alt="WeChat Logo">
                            <div class="wechat-icon-hover"></div>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
    </nav>
</template>

<script>
export default {
    name: 'navBar',
    data() {
        return {
            scrolled: false,
            navTextDark: false,  // true=图片偏亮用深色文字，false=图片偏暗用白色文字
        }
    },
    mounted() {
        this._handleScroll = () => {
            const isHome = this.$route && (this.$route.path === '/' || this.$route.path === '/home')
            this.scrolled = !isHome || window.scrollY > 60
        }
        window.addEventListener('scroll', this._handleScroll, { passive: true })
        this._handleScroll()

        this._onBright = (isDark) => { this.navTextDark = isDark }
        this.$root.$on('hero-nav-bright', this._onBright)
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this._handleScroll)
        this.$root.$off('hero-nav-bright', this._onBright)
    },
    watch: {
        $route() {
            this.$nextTick(this._handleScroll)
        }
    },
    methods: {
        changeLang(lang) {
            this.$i18n.locale = lang;
            localStorage.setItem("lang", lang)
            location.reload();
        }
    }
}
</script>

<style scoped>

/* ===== 固定导航栏 ===== */
#header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    width: 100%;
    transition: background-color 0.35s ease, box-shadow 0.35s ease;
}

/* ===== 图标过渡 ===== */
.navbar-brand img,
.navbar-link img {
    transition: filter 0.35s ease;
}

/* 透明 + 暗图：logo 和 earth icon 变为纯白 */
.is-nav-transparent .navbar-brand img,
.is-nav-transparent:not(.nav-text-dark) .navbar-link img {
    filter: brightness(0) invert(1);
}

/* 滚动后 或 亮图：还原正常颜色 */
.is-scrolled .navbar-brand img {
    filter: none;
}

/* ===== 透明状态：沉浸在轮播图上（图片偏暗 → 白色文字）===== */
.is-nav-transparent {
    background-color: transparent;
}

.is-nav-transparent .navbar-link,
.is-nav-transparent .navbar-item,
.is-nav-transparent .navbar-item strong {
    color: rgba(255, 255, 255, 0.92) !important;
}

/* 下拉箭头跟随文字颜色（Bulma 写死了 border-color，用 currentColor 覆盖） */
.is-nav-transparent .navbar-link::after {
    border-color: transparent transparent currentColor currentColor !important;
}

.is-nav-transparent .navbar-link:hover,
.is-nav-transparent .navbar-item:hover {
    background-color: rgba(255, 255, 255, 0.12) !important;
    color: #fff !important;
}

.is-nav-transparent .navbar-dropdown {
    background-color: rgba(5, 18, 42, 0.94) !important;
    border-top-color: rgba(255, 255, 255, 0.15) !important;
}

.is-nav-transparent .navbar-dropdown .navbar-item {
    color: rgba(255, 255, 255, 0.85) !important;
}

.is-nav-transparent .navbar-dropdown .navbar-item:hover {
    background-color: rgba(255, 255, 255, 0.1) !important;
    color: #fff !important;
}

/* ===== 透明 + 亮图：深色文字 ===== */
.is-nav-transparent.nav-text-dark .navbar-link,
.is-nav-transparent.nav-text-dark .navbar-item,
.is-nav-transparent.nav-text-dark .navbar-item strong {
    color: rgba(20, 20, 20, 0.85) !important;
}

.is-nav-transparent.nav-text-dark .navbar-link::after {
    border-color: transparent transparent currentColor currentColor !important;
}

.is-nav-transparent.nav-text-dark .navbar-link:hover,
.is-nav-transparent.nav-text-dark .navbar-item:hover {
    background-color: rgba(0, 0, 0, 0.07) !important;
    color: #000 !important;
}

.is-nav-transparent.nav-text-dark .navbar-dropdown {
    background-color: rgba(255, 255, 255, 0.97) !important;
    border-top-color: rgba(0, 0, 0, 0.1) !important;
}

.is-nav-transparent.nav-text-dark .navbar-dropdown .navbar-item {
    color: rgba(20, 20, 20, 0.82) !important;
}

.is-nav-transparent.nav-text-dark .navbar-dropdown .navbar-item:hover {
    background-color: rgba(0, 0, 0, 0.05) !important;
    color: #000 !important;
}

/* 亮图时：logo 和 earth icon 还原正常颜色 */
.is-nav-transparent.nav-text-dark .navbar-brand img,
.is-nav-transparent.nav-text-dark .navbar-link img {
    filter: none;
}

/* 取消 Bulma 在下拉展开时给父级 navbar-link 加的背景色 */
.navbar-item.has-dropdown:hover .navbar-link,
.navbar-item.has-dropdown.is-active .navbar-link {
    background-color: transparent !important;
}

/* 取消 Vue Router 激活链接的白色背景 */
.navbar-item.router-link-active,
.navbar-item.router-link-exact-active,
.navbar-item:focus,
.navbar-item:active {
    background-color: transparent !important;
}

/* 激活菜单项始终显示红色（比 is-nav-transparent 的 !important 优先级更高） */
.is-nav-transparent .navbar-item.router-link-exact-active,
.is-scrolled .navbar-item.router-link-exact-active {
     /* color: #3675D9 !important; */
}

/* 滚动后白色状态 */
.is-scrolled {
    background-color: #fff;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.wechat-icon {
    position: relative;
    width: 35px;
    height: 35px;
}

.wechat-icon .wechat-logo {
    width: 100%;
    height: 100%;
}

.wechat-icon .wechat-icon-hover {
    position: absolute;
    top: calc(100% + 20px); /* 在 weixin_logo.svg 下面 20px 的位置 */
    left: 0;
    background-image: url("../assets/weixin.png"); /* 设置背景图 */
    background-repeat: no-repeat;
    background-size: 200px; /* 背景图片大小 */
    opacity: 0;
    transition: opacity 0.5s ease-in-out;
}

.wechat-icon:hover .wechat-icon-hover {
    width: 200px; /* 设置宽度为 200px */
    height: 200px; /* 设置高度为 200px */
    opacity: 1;
}


</style>
